import React from "react";

export default class CompAbout extends React.Component<any, any> {
    render() {
        return (
            <div className='container'>
                <div className="text-center">
                    <h2 className="section-heading text-uppercase">About</h2>
                    <h3 className="section-subheading text-muted">&nbsp;</h3>
                </div>
                <ul className="timeline">
                    <li>
                        <div className="timeline-image">
                            <img className="rounded-circle img-fluid"
                                 src="../assets/img/about/1.jpg" alt="..."/></div>
                        <div className="timeline-panel">
                            <div className="timeline-heading">
                                <h4>May. 2020</h4>
                                <h4 className="subheading">Our Beginnings</h4>
                            </div>
                            <div className="timeline-body">
                                <p className="text-muted">Smart lighting control system and
                                    Development of power usage analysis system</p>
                            </div>
                        </div>
                    </li>
                    <li className="timeline-inverted">
                        <div className="timeline-image">
                            <img className="rounded-circle img-fluid"
                                 src="../assets/img/about/image1.png" alt="..."/></div>
                        <div className="timeline-panel">
                            <div className="timeline-heading">
                                <h4>2021</h4>
                                <h4 className="subheading">Metaverse technology development in progress</h4>
                            </div>
                            <div className="timeline-body">
                                <p className="text-muted">Development of technology to transmit content by building an ad hoc network in small spatial units</p>
                                <p>Patent registration</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="timeline-image">
                            <img className="rounded-circle img-fluid"
                                 src="../assets/img/about/image2.png" alt="..."/></div>
                        <div className="timeline-panel">
                            <div className="timeline-heading">
                                <h4>2022</h4>
                                <h4 className="subheading">Develop data analysis solutions</h4>
                            </div>
                            <div className="timeline-body">
                                <p className="text-muted">Establishment of fine dust emissions inventory system according to commercial area and population distribution within residential area, data visualization, and construction of public data (OpenAPI) system</p>
                            </div>
                        </div>
                    </li>
                    <li className="timeline-inverted">
                        <div className="timeline-image">
                            <img className="rounded-circle img-fluid"
                                 src="../assets/img/about/image3.png" alt="..."/></div>
                        <div className="timeline-panel">
                            <div className="timeline-heading">
                                <h4>2023</h4>
                                <h4 className="subheading">Enhancing data analysis and IoT control solutions</h4>
                            </div>
                            <div className="timeline-body">
                                <p className="text-muted">Development of public waste collection facility status and monitoring technology.</p>
                                <p className="text-muted">Patent: Recyclable resource unmanned collection system and method</p>
                            </div>
                        </div>
                    </li>
                    <li className="timeline-inverted">
                        <div className="timeline-image">
                            <h4>
                                Be Part
                                <br/>
                                Of Our
                                <br/>
                                Story!
                            </h4>
                        </div>
                    </li>
                </ul>
            </div>
        );
    }
}
